(function ($) {
    $(document).ready(function () {

        if ($(".we-say-section").length > 0) {

            let we_say_left_swiper = new Swiper('.we_say_left_swiper', {
                slidesPerView: 1,
                direction: "vertical",
                centeredSlides: true,
                loop: true,
                autoplay: {
                    delay: 1000,
                },
                allowTouchMove: false,
            });

            let we_say_right_swiper = new Swiper('.we_say_right_swiper', {
                slidesPerView: 1,
                direction: "vertical",
                centeredSlides: true,
                loop: true,
                autoplay: {
                    delay: 1000,
                },
                allowTouchMove: false,
            });
        }

    });
})(jQuery);